import { render } from "./App.vue?vue&type=template&id=50965d49"
const script = {}

import "./App.vue?vue&type=style&index=0&id=50965d49&lang=less"

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_7343fc8c6ccbd95e30a548a545b8f552/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__